import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;

  margin-bottom: 0.6rem;

  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    position: absolute;
    right: 30px;
    font-size: 16px;
    cursor: pointer;
    color: #2253f5;
  }
`;

export const InputStyle = styled.input`
  background: transparent;
  border: 1px solid #2253f5;
  border-radius: 100px;
  width: 181.69px;
  height: 31.99px;
  height: 40px;
  padding: 0 10px;

  font-family: Montserrat;
  font-size: 13px;
  line-height: 140.62%;
  color: #2253f5;

  &::placeholder {
    font-family: Montserrat;
    font-style: italic;
    font-size: 13px;
    line-height: 140.62%;
    color: #2253f5;
  }
`;
